<template>
  <div class="social-buttons">
    <button><svg-icon name="google" /> Продолжить с Google</button>
    <button><svg-icon name="facebook" /> Продолжить с Facebook</button>
  </div>
</template>

<script>
export default {
  name: 'SocialButtons'
}
</script>

<style scoped lang="scss">
.social-buttons {
  margin: 0 36px;

  @include md-and-down {
    margin: 0;
  }

  button {
    padding: 12px 0;
    justify-content: center;
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 24px;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.35px;
    transition: 0.3s;

    @include md-and-down {
      padding: 9px 0;
      font-size: 14px;
      line-height: 17px;
    }

    &:hover {
      opacity: 0.7;
    }

    svg {
      width: 24px;
      height: 24px;
      margin-right: 8px;

      @include md-and-down {
        width: 16px;
        height: 16px;
        margin-right: 12px;
      }
    }

    &:first-of-type {
      color: $deepdark;
      border: 1px solid $french-gray;
    }

    &:last-of-type {
      margin-top: 16px;
      background: $luchmara;
      color: $white;

      @include md-and-down {
        margin-top: 8px;
      }

      svg::v-deep path {
        fill: $whisper;
      }
    }
  }
}
</style>
